module.exports = __webpack_public_path__ + "img/grey-video.78cb9677.svg";